import { Flex, Text } from '@chakra-ui/react'
import { DateTimeRangeDropdown } from '~/components/shared/DateTimeRangeDropdown'
import { DateRange } from '~/types/Shared'

type CallVolumeFiltersProps = {
  dateTimeRange?: DateRange
  onValueChange: (newRange: DateRange) => void
}

const CallVolumeFilters = ({
  dateTimeRange,
  onValueChange,
}: CallVolumeFiltersProps) => {
  return (
    <Flex
      width="100%"
      height="4.5rem"
      padding="0rem 1.25rem"
      justifyContent="space-between"
      alignItems="center"
      alignSelf="stretch"
      borderBottom="2px solid gray.400"
      background="gray.200"
    >
      <Text
        fontSize="1.25rem"
        fontWeight="800"
        lineHeight="1.75rem"
        color="gray.1300"
      >
        Call Volume
      </Text>
      <Flex gap="0.75rem">
        <DateTimeRangeDropdown
          onValueChange={onValueChange}
          dateTimeRange={dateTimeRange}
          useExtendedDates={true}
          useQuickActionButton={false}
        />
      </Flex>
    </Flex>
  )
}

export default CallVolumeFilters
